export default "__VITE_ASSET__Dle5FaLt__"